import helper from '../js/helper';

export default function meiliPagination (renderOptions, { html }, { locale, selectorTab }) {
  const meiliTotalCountEl = document.querySelector(`${selectorTab} [data-meilisearch-count]`);

  const isEnglish = locale === 'en';

  const { nbHits, nbSortedHits, hitsPerPage, page, processingTimeMS, query } = renderOptions;

  const start = page * hitsPerPage + 1;
  const end = Math.min(start + hitsPerPage - 1, nbHits);

  if (meiliTotalCountEl) {
    meiliTotalCountEl.innerHTML = nbHits.toLocaleString();
  }

  if (isEnglish) {
    return html`
      <div class="mt-4 text-muted">
        <i>Showing ${start} to ${end} of ${nbHits.toLocaleString()} entries</i>
      </div>
    `;
  }

  return html`
    <div class="mt-4 text-muted">
      <i>Menampilkan ${start} s/d ${end} dari ${nbHits.toLocaleString()} data</i>
    </div>
  `;
}